import { Time } from '@angular/common';
import { IProduct } from '../apitypes';
import { IProductNotification } from './IProductNotification';

export class ProductCreate {
    product: IProduct;
    location: Location;
    date: Time;
}